import Vue from "vue";
import { DatePicker } from "v-calendar";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { requestAccountCreation } from "@/services";
import dayjs from "dayjs";
import { getAccountLookupForm, } from "@/store/modules/accountLookup";
const Modal = () => import("@/components/Modal.vue");
const TextField = () => import("@/components/TextField.vue");
const Button = () => import("@/components/Button.vue");
const ValidationError = () => import("@/components/ValidationError.vue");
const Alert = () => import("@/components/Alert.vue");
const Icon = () => import("@/components/Icon/index.vue");
const SelectField = () => import("@/components/SelectField.vue");
const ButtonForgotNpsn = () => import("./ButtonForgotNpsn.vue");
export default Vue.extend({
    components: {
        Alert,
        Modal,
        TextField,
        Button,
        ValidationError,
        ValidationObserver,
        ValidationProvider,
        Icon,
        SelectField,
        DatePicker,
        ButtonForgotNpsn,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        submitting: {
            type: Boolean,
            default: false,
        },
        success: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        isOpen: false,
        email: "",
        masks: {
            input: "YYYY-MM-DD",
        },
        rules: {
            fullName: "required",
            motherName: "required",
            type: "required",
            birthDate: "required",
            npsn: "required",
            phone: "required",
            email: "required|email",
        },
        defaultForm: {
            fullName: "",
            motherName: "",
            type: "",
            birthDate: "",
            npsn: "",
            email: "",
            phone: "",
        },
        form: {
            fullName: "",
            motherName: "",
            type: "",
            birthDate: "",
            npsn: "",
            email: "",
            phone: "",
        },
        loading: false,
        isError: false,
        errorMessage: "",
    }),
    computed: {
        userTypes() {
            return [
                {
                    text: this.$getContent("accountLookup.form.userTypePlaceholder"),
                    value: "",
                    disabled: true,
                    selected: true,
                },
                {
                    text: "Peserta Didik",
                    value: "pd",
                },
                {
                    text: "Pendidik dan Tenaga Kependidikan",
                    value: "ptk",
                },
            ];
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.isOpen = val;
            },
        },
        isOpen(val) {
            this.$emit("input", val);
        },
    },
    mounted() {
        const form = getAccountLookupForm();
        const types = {
            student: "pd",
            teacher: "ptk",
        };
        // console.log(form, types);
        this.form = {
            fullName: form === null || form === void 0 ? void 0 : form.fullName,
            motherName: String(form === null || form === void 0 ? void 0 : form.motherName),
            type: types[String(form === null || form === void 0 ? void 0 : form.userType)],
            birthDate: form === null || form === void 0 ? void 0 : form.dateOfBirth,
            npsn: form === null || form === void 0 ? void 0 : form.npsn,
            email: "",
            phone: "",
        };
    },
    methods: {
        async onSubmit() {
            var _a, _b;
            this.isError = false;
            this.errorMessage = "";
            this.loading = true;
            try {
                const res = await requestAccountCreation(this.form.type, {
                    full_name: this.form.fullName,
                    npsn: this.form.npsn,
                    birth_date: dayjs(this.form.birthDate).format("YYYY-MM-DD"),
                    email: this.form.email,
                    mother_name: this.form.motherName,
                });
                if (res.status === 200) {
                    this.$emit("success", res.data);
                }
            }
            catch (e) {
                this.isError = true;
                this.errorMessage = ((_b = (_a = e.response.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message) || e.message;
            }
            finally {
                this.loading = false;
            }
        },
        close() {
            this.$emit("input", false);
        },
    },
});
